import React, { useCallback, useEffect, useRef, useState } from "react";

const WOMEN = [
  { slug: "ashley-serrato", name: "ASHLEY SERRATO, 39", alt: "Ashley Serrato", tag: "DOESN'T GET ANY BETTER!", sub: "Wicksburg, Alabama", quote: "She is the real deal." },
  { slug: "monica-everheart", name: "MONICA EVERHEART, 44", alt: "Monica Everheart", tag: "SANDRA CHANGED MY LIFE!", sub: "Dothan, Alabama", quote: "Sandra's passion for fitness and for helping women become stronger, both physically and mentally, is contagious." },
  { slug: "sherry-jacques", name: "SHERRY JACQUES, 57", alt: "Sherry Jacques", tag: "NOT A GYM PERSON", sub: "Retired Attorney", quote: "Two and a half years later I'm stronger and more confident in my body than I ever imagined I'd be." },
  { slug: "ashley-meadows", name: "ASHLEY MEADOWS, 58", alt: "Ashley Meadows", tag: "LOST 10 LBS WITH REAL MUSCLE TONE", sub: "Fitness Instructor in the '90s", quote: "In six months I lost 10 pounds, gained real muscle tone, and my posture is noticeably better." },
  { slug: "mary-helen-richards", name: "MARY HELEN RICHARDS, 62", alt: "Mary Helen Richards", tag: "MUSCLE GROWTH ACHIEVED", sub: "Muscle & Mindset", quote: "The muscle growth and transformation of my body has surpassed my expectations." },
  { slug: "debbie-strain", name: "DEBBIE STRAIN, 63", alt: "Debbie Strain", tag: "ALL OF MY LABS IMPROVED", sub: "Household CEO", quote: "I just left my doctor's office with my new bloodwork results and everything is so much better." },
  { slug: "cynthia-nowell", name: "CYNTHIA NOWELL, 73", alt: "Cynthia Nowell", tag: "STRONGER & HEALTHIER AT 74", sub: "Strength & Longevity", quote: "A year later I'm stronger, my labs have improved, and I'm proud of what we accomplished." },
];

// Styles supplied by the user (success_section.html) — verbatim, scoped to .sfs-sw.
const CSS = `
.sfs-sw{max-width:1100px;margin:5rem auto 0;padding:8px 0 4px;font-family:Inter,-apple-system,"Segoe UI",sans-serif;color:#fafafa}
.sfs-sw *{box-sizing:border-box}
.sfs-sw__h{font-family:Archivo,sans-serif;font-weight:900;font-size:clamp(28px,4.4vw,40px);line-height:1.1;text-transform:uppercase;text-align:center;margin:0 0 8px;color:#fff}
.sfs-sw__h span{color:#D4AF35}
.sfs-sw__intro{text-align:center;font-size:18px;color:rgba(255,255,255,.75);margin:0 0 26px}
.sfs-sw__wrap{position:relative}
.sfs-sw__row{display:flex;gap:18px;overflow-x:auto;scroll-snap-type:x mandatory;scroll-padding-left:24px;padding:4px 24px 14px;scrollbar-width:none;-webkit-overflow-scrolling:touch}
.sfs-sw__row::-webkit-scrollbar{display:none}
.sfs-sw__card{flex:0 0 calc((100% - 54px)/4.15);scroll-snap-align:start;display:flex;flex-direction:column;text-align:left;background:#111;border:1px solid #2a2a2a;border-radius:16px;overflow:hidden;padding:0;cursor:pointer;color:inherit;font:inherit;transition:border-color .2s,transform .2s}
.sfs-sw__card:hover,.sfs-sw__card:focus-visible{border-color:#D4AF35;transform:translateY(-2px);outline:none}
.sfs-sw__photo{display:block;aspect-ratio:4/5;background:#1a1a1a}
.sfs-sw__photo img{width:100%;height:100%;object-fit:cover;display:block}
.sfs-sw__body{display:flex;flex-direction:column;padding:16px 18px 18px;flex:1}
.sfs-sw__tag{align-self:flex-start;font-weight:700;font-size:10.5px;letter-spacing:1.4px;color:#D4AF35;border:1px solid rgba(212,175,53,.5);border-radius:20px;padding:4px 10px;margin-bottom:12px}
.sfs-sw__name{font-family:Archivo,sans-serif;font-weight:900;font-size:18px;line-height:1.15;color:#fff}
.sfs-sw__sub{font-size:13px;color:rgba(255,255,255,.55);margin:3px 0 12px}
.sfs-sw__quote{font-style:italic;font-size:15px;line-height:1.5;color:rgba(255,255,255,.88);flex:1}
.sfs-sw__more{margin-top:14px;font-weight:700;font-size:13px;letter-spacing:.6px;color:#D4AF35}
.sfs-sw__nav{position:absolute;left:0;right:0;top:var(--arrow-top,160px);transform:translateY(-50%);display:flex;justify-content:space-between;padding:0 2px;pointer-events:none;z-index:2}
.sfs-sw__arrow{pointer-events:auto;box-shadow:0 2px 12px rgba(0,0,0,.7);width:44px;height:44px;border-radius:50%;border:1px solid #D4AF35;background:#0a0a0a;color:#D4AF35;font-size:20px;line-height:1;cursor:pointer;display:flex;align-items:center;justify-content:center;}
.sfs-sw__arrow[disabled]{opacity:.25;cursor:default}
.sfs-sw__hint{text-align:center;font-size:12px;letter-spacing:1.6px;color:rgba(255,255,255,.4);margin-top:6px;display:none}
.sfs-sw__modal{position:fixed;inset:0;background:rgba(0,0,0,.86);display:none;align-items:flex-start;justify-content:center;padding:28px 14px;overflow-y:auto;z-index:9999}
.sfs-sw__modal.is-open{display:flex}
.sfs-sw__panel{position:relative;max-width:680px;width:100%;margin:auto}
.sfs-sw__panel img{width:100%;height:auto;display:block;border-radius:14px}
.sfs-sw__close{position:absolute;top:-14px;right:-6px;width:40px;height:40px;border-radius:50%;border:none;background:#D4AF35;color:#0d0d0d;font-size:22px;font-weight:700;cursor:pointer}
@media (max-width:760px){
  .sfs-sw__card{flex-basis:78%}
  .sfs-sw__row{padding:4px 16px 12px;gap:14px;scroll-padding-left:16px}
  .sfs-sw__nav{display:none}
  .sfs-sw__hint{display:block}
}
`;

export const SuccessStories = () => {
  const rowRef = useRef(null);
  const wrapRef = useRef(null);
  const [arrowTop, setArrowTop] = useState(160);
  const closeRef = useRef(null);
  const lastCard = useRef(null);
  const [atStart, setAtStart] = useState(true);
  const [atEnd, setAtEnd] = useState(false);
  const [open, setOpen] = useState(null);

  const upd = useCallback(() => {
    const row = rowRef.current;
    if (!row) return;
    setAtStart(row.scrollLeft < 8);
    setAtEnd(row.scrollLeft + row.clientWidth >= row.scrollWidth - 8);
    const photo = row.querySelector(".sfs-sw__photo");
    if (photo && wrapRef.current) {
      const p = photo.getBoundingClientRect();
      setArrowTop(Math.round(p.top - wrapRef.current.getBoundingClientRect().top + p.height / 2));
    }
  }, []);

  useEffect(() => {
    upd();
    window.addEventListener("resize", upd);
    return () => window.removeEventListener("resize", upd);
  }, [upd]);

  const step = () => {
    const c = rowRef.current?.querySelector(".sfs-sw__card");
    return c ? c.getBoundingClientRect().width + 18 : 300;
  };

  const close = useCallback(() => {
    setOpen(null);
    document.body.style.overflow = "";
    lastCard.current?.focus();
  }, []);

  useEffect(() => {
    if (!open) return;
    document.body.style.overflow = "hidden";
    closeRef.current?.focus();
    const onKey = (ev) => ev.key === "Escape" && close();
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, close]);

  const openProfile = (w, el) => {
    lastCard.current = el;
    setOpen(w);
  };

  return (
    <section className="sfs-sw w-[90%] mx-auto mt-20" aria-labelledby="sfs-sw-h" data-testid="success-stories">
      <style>{CSS}</style>
      <h2 className="sfs-sw__h" id="sfs-sw-h">
        Women Who Got It <span>Back.</span>
        <br />
        Ages 39 to 73
      </h2>
      <p className="sfs-sw__intro">These clients started exactly where you are.</p>
      <div className="sfs-sw__wrap" ref={wrapRef} style={{ "--arrow-top": `${arrowTop}px` }}>
        <div className="sfs-sw__row" tabIndex={0} ref={rowRef} onScroll={upd} data-testid="success-stories-row">
          {WOMEN.map((w) => (
            <button
              key={w.slug}
              className="sfs-sw__card"
              type="button"
              aria-label={`Read ${w.alt}'s story`}
              onClick={(e) => openProfile(w, e.currentTarget)}
              data-testid={`success-card-${w.slug}`}
            >
              <span className="sfs-sw__photo">
                <img src={`/success/photo-${w.slug}.jpg`} alt={w.alt} loading="lazy" />
              </span>
              <span className="sfs-sw__body">
                <span className="sfs-sw__tag">{w.tag}</span>
                <span className="sfs-sw__name">{w.name}</span>
                <span className="sfs-sw__sub">{w.sub}</span>
                <span className="sfs-sw__quote">&ldquo;{w.quote}&rdquo;</span>
                <span className="sfs-sw__more">Read her story &rarr;</span>
              </span>
            </button>
          ))}
        </div>
        <div className="sfs-sw__nav">
          <button className="sfs-sw__arrow sfs-sw__arrow--prev" type="button" aria-label="Previous" disabled={atStart} onClick={() => rowRef.current.scrollBy({ left: -step(), behavior: "smooth" })} data-testid="success-prev">
            &#8592;
          </button>
          <button className="sfs-sw__arrow sfs-sw__arrow--next" type="button" aria-label="Next" disabled={atEnd} onClick={() => rowRef.current.scrollBy({ left: step(), behavior: "smooth" })} data-testid="success-next">
            &#8594;
          </button>
        </div>
      </div>
      <p className="sfs-sw__hint">SWIPE TO SEE MORE &rarr;</p>
      <div
        className={`sfs-sw__modal${open ? " is-open" : ""}`}
        role="dialog"
        aria-modal="true"
        aria-label="Client story"
        onClick={(ev) => ev.target === ev.currentTarget && close()}
        data-testid="success-modal"
      >
        <div className="sfs-sw__panel">
          <button className="sfs-sw__close" type="button" aria-label="Close" ref={closeRef} onClick={close} data-testid="success-modal-close">
            &times;
          </button>
          {open && <img src={`/success/profile-${open.slug}.png`} alt={`${open.name} success profile`} data-testid="success-modal-img" />}
        </div>
      </div>
    </section>
  );
};
